import type jsPDF from "jspdf";
import {
  MONCO_FALLBACK_TEXT,
  MONCO_FALLBACK_TEXT_COLOR,
  MONCO_URL,
} from "./constants";
import type { BrandHeader } from "./types";

export const buildFallbackHeader = (
  doc: jsPDF,
  fallbackFontSize: number,
): BrandHeader => {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(fallbackFontSize);
  return {
    width: doc.getTextWidth(MONCO_FALLBACK_TEXT),
    height: fallbackFontSize,
    draw: (originX, originY) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(fallbackFontSize);
      doc.setTextColor(...MONCO_FALLBACK_TEXT_COLOR);
      doc.textWithLink(
        MONCO_FALLBACK_TEXT,
        originX,
        originY + fallbackFontSize,
        { url: MONCO_URL },
      );
    },
  };
};
